import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from '@config/app.config';
import { CustomersService } from '@core/services/customers.service';
import { GeneralsService } from '@core/services/generals.service';
import { ValidationsService } from '@core/services/validations.service';
import { CustomersListComponent } from '@modules/customers/customers-list/customers-list.component';
import { Constants } from '@shared/class/constants.class';
import { TypeIdentify } from '@shared/interfaces/customer';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-customers-filter',
  templateUrl: './customers-filter.component.html'
})
export class CustomersFilterComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public typesIdentifyList: Array<TypeIdentify> = [];
  public customerForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public customersService: CustomersService
  ) {}

  ngOnInit() {
    this.customersService
      .getTypeIdentify()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.constants.error = false;
          this.constants.loading = false;
          result.data.forEach((element: any) => {
            let typeIdentify: TypeIdentify;
            typeIdentify = { id: element.id, name: element.attributes.name };
            this.typesIdentifyList.push(typeIdentify);
          });
          this.customerForm = new FormGroup({
            typeIdentify: new FormControl('', Validators.required),
            identify: new FormControl('', [
              Validators.required,
              ValidationsService.isInvalidNumberValidator
            ])
          });
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.customerForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      this.customersService
        .getItemId(form.value.typeIdentify, form.value.identify)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            loading.close();
            if (
              Object.keys(result).length > 0 &&
              Object.keys(result.data).length > 0
            ) {
              this.generalsService.modal(
                CustomersListComponent,
                result.data,
                'mat-modal-big'
              );
            } else {
              this.generalsService.notification(
                this.appConfig.NOTIFICATION.info,
                this.appConfig.LANG.customers.noCustomer
              );
            }
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }
}
